import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import LivingMenu from '../../components/menus/FYH';
import ResultsWrapper from './ResultsWrapper';
import ContactBanner from '../../components/ContactBanner';
import ContentBanner from '../../components/ContentBanner';
import { typography } from '../../styles';

const styles = css`
  background-color: #000000;
  .ContentBanner_titleAlt {
    display: block;
    width: 100%;
    font-family: ${typography.SansSerif};
    font-weight: 300;
    font-size: 24px;
    color: #C7BD8C;
    letter-spacing: 0;
    background: -webkit-linear-gradient(#C7BD8C, #9F8B54);
    -webkit-background-clip: text;
    margin-top: 100px;
    margin-bottom: 50px;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 35px;
    }
    @media(min-width: 1200px) {
      font-size: 40px;
    }
  }
`;

const insideHeaderStyles = css`
`;


function Communities({ area, builder, widget }) {
  const pageImage = get(widget, 'page_image.contentUrl');
  const areaName = get(area, 'name', 'Broken Arrow');
  const pageTitle = `${areaName} New Home Communities`;
  const metaDescription = 'Find the perfect community for your new home in Forest Ridge\'s master-planned community in Broken Arrow, OK.';
  const welcome = get(widget, 'welcome_section[0]');

  return (
    <PageWrapper className={styles} builder={builder}>
      <PageHelmet
        custom
        title={pageTitle}
      >
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={buildThumbnailUrl(pageImage, { width: 1200, height: 1200 })} />
        <meta property="og:title" content={pageTitle} />
        <meta name="description" content={metaDescription} />
      </PageHelmet>
      <InsideHeader
        className={insideHeaderStyles}
        title="Neighborhoods"
        postTitle={get(widget, 'page_subtitle')}
        background={pageImage}
      />
      <LivingMenu />
      <ContentBanner
        title={welcome.title}
        lead={welcome.lead_copy}
        image={welcome.image}
        video={welcome.video}
      />
      <ResultsWrapper area={area} />
      <ContactBanner />
    </PageWrapper>
  );
}

Communities.propTypes = {
  area: PropTypes.object,
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

Communities.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    builder: true,
    widget: 'communities',
  },
  {
    required: {
      builder: true,
      widget: true,
    },
  },
)(Communities);



// WEBPACK FOOTER //
// ./src/pages/Communities/index.js